import React from 'react'
import { BooleanInput, NumberInput } from 'react-admin'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import ExclusiveBoolean from 'ui-shared/WrappedInputs/ExclusiveBoolean'
import { useFormContext } from 'react-hook-form'
import { OptionGroup } from 'services/api/entities/catalog/optionedProduct/types/internal/optionedProduct-models'

type Props = ArrayInputContentProps & {
  acceptsQuantityDependentSources: string[]
}

const OptionGroupSettings: React.FC<Props> = ({
  acceptsQuantityDependentSources,
  source,
}) => {
  const {
    scopedFormData: { acceptsQuantity, infoBox },
    kGetSource,
  } = useKArrayInput<OptionGroup>(source)

  // TODO improve further the typing by passing a root with index to
  // TODO the useKArrayInput the kGetSource function returns the concat
  // TODO of this with all the possible paths
  const { setValue } = useFormContext()

  // #870 if infoBox is true we disable the acceptsQuantity field and set it to false
  const onIsInfoBoxChange = (_event: any, e: boolean): void => {
    if (!e) {
      setValue(kGetSource('maxSelection'), 1)
      setValue(kGetSource('acceptsQuantity'), false)
    }
  }

  const onAcceptsQuantityChange = (_event: any, e: boolean): void => {
    if (!e) {
      setValue(kGetSource('maxSelection'), 1)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <NumberInput
        source={kGetSource!('maxSelection')}
        label="form.fields.maxOptions"
        disabled={!acceptsQuantity}
        style={{ margin: '0 30px  0 0' }}
      />
      <BooleanInput
        source={kGetSource!('infoBox')}
        label="form.fields.infoBox"
        defaultValue={false}
        onChange={onIsInfoBoxChange}
      />
      <ExclusiveBoolean
        source={kGetSource('acceptsQuantity')}
        label="form.fields.acceptsQuantity"
        defaultValue={true}
        disabled={infoBox}
        dependentFieldsSources={acceptsQuantityDependentSources}
        onChange={onAcceptsQuantityChange}
      />
    </div>
  )
}

export default OptionGroupSettings
